import { flow, Instance, types } from "mobx-state-tree";
import { salesTaxService } from "@fidget/common/services/salesTaxService";
import { logger } from "@fidget/common/utils";
import { servicesGetters } from "../utils";

export const PaymentStore = types
  .model("PaymentStore", {
    isReverseTax: types.maybe(types.boolean),
    taxRate: types.maybe(types.number),
    isCompanyIdValid: types.maybe(types.boolean),
    companyId: types.maybe(types.string)
  })
  .views(servicesGetters)
  .actions((self) => ({
    getTaxRate: flow(function* (countryCode: string, vatId?: string) {
      try {
        let isVatValid = false;
        if (countryCode === "PL") {
          isVatValid = true;
        } else {
          const vatIdForSpinner = vatId!.slice(2).trim();
          const spinnerResponse = yield self.spinnerService.checkVat({
            countryCode,
            vatId: vatIdForSpinner
          });
          isVatValid = spinnerResponse.valid;
        }

        if (vatId && isVatValid) {
          const { rate, charge } = yield salesTaxService.getSalesTax(countryCode, vatId);
          self.isReverseTax = charge.reverse;
          self.taxRate = rate;
          self.companyId = vatId;
          self.isCompanyIdValid = true;
        } else {
          const { rate, area } = yield salesTaxService.getSalesTax(countryCode);
          if (area === "international" || area === "worldwide") {
            self.taxRate = 0;
          } else {
            self.taxRate = rate;
          }
          self.isReverseTax = false;
          self.companyId = vatId;
          self.isCompanyIdValid = false;
        }
      } catch (e) {
        logger.error("Could not check vat id");
      }
    })
  }));

export type IPaymentStore = Instance<typeof PaymentStore>;
